import { History } from 'history';

const Redirecting = ({ history }: { history: History }) => {
  history.replace('/error/404');
  return null;
};

export default Redirecting;
